<template>
  <v-tooltip left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        large
        color="blue-grey"
        class="white--text"
        v-bind="attrs"
        v-on="on"
        @click="signout"
      >
        <v-icon small>
          logout
        </v-icon>
      </v-btn>
    </template>
    <span>Sign out</span>
  </v-tooltip>
</template>

<script>
import SignOut from '../models/signOut'

export default {
  created() {
    const self = this
    this.$bus.$on('signOut', () => {
      self.signout()
    })
  },
  methods: {
    async signout() {
      const result = await SignOut.signOut(this)
      // console.log(`signout reuslt:: ${result}`)
      if (result === true) {
        this.$router.push('/').catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
